'use strict';
(function () {
  if (window.VSKLOCartAddonService) return;

  function normalizeAddonType(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
  }

  function getAddonServiceType(addon) {
    if (window.VSKLOAddonEngine) return window.VSKLOAddonEngine.serviceType(addon);
    if (!addon) return 'other';

    var explicitType = normalizeAddonType(
      addon.dataset.vskloAddonType ||
      addon.dataset.vskloServiceType ||
      addon.dataset.vskloAddonKind ||
      addon.dataset.addonType ||
      addon.dataset.type ||
      ''
    );

    if (['engraving_glass', 'glass_engraving', 'engraving', 'personalization'].includes(explicitType)) return 'engraving_glass';
    if (['engraving_packaging', 'packaging_engraving', 'box_engraving'].includes(explicitType)) return 'engraving_packaging';
    if (['gift_packaging', 'gift_package', 'packaging', 'package', 'gift_bag', 'bag'].includes(explicitType)) return 'gift_packaging';
    if (['postcard', 'gift_card', 'card', 'letter'].includes(explicitType)) return 'postcard';
    if (explicitType === 'other') return 'other';

    var title = String(
      addon.querySelector('.product-addons-popup__addon-name')?.textContent ||
      addon.dataset.addonTitle ||
      ''
    ).toLowerCase();
    var looksLikeEngraving =
      title.includes('грав') ||
      title.includes('нанес') ||
      title.includes('engraving') ||
      title.includes('personalization');
    var looksLikePackaging =
      title.includes('пакет') ||
      title.includes('пакув') ||
      title.includes('упаков') ||
      title.includes('package') ||
      title.includes('bag') ||
      title.includes('box') ||
      title.includes('короб');

    if (looksLikeEngraving && looksLikePackaging) return 'engraving_packaging';
    if (looksLikeEngraving) return 'engraving_glass';
    if (looksLikePackaging) return 'gift_packaging';
    if (
      title.includes('листів') ||
      title.includes('відкрит') ||
      title.includes('postcard') ||
      title.includes('gift card')
    ) return 'postcard';

    return 'other';
  }

  function getRequiredTextMessage(addon, t) {
    var serviceType = getAddonServiceType(addon);
    if (serviceType === 'postcard') {
      return t('fillPostcardText', 'Введіть текст листівки');
    }
    return t('fillEngravingText', 'Введіть текст для гравіювання');
  }

  function isNoEngravingAddon(addon) {
    if (window.VSKLOAddonEngine) return window.VSKLOAddonEngine.isNoText(addon);
    if (!addon) return false;

    var serviceType = getAddonServiceType(addon);
    if (serviceType === 'gift_packaging') return true;
    if (serviceType === 'postcard') return false;
    if (
      serviceType === 'engraving_glass' ||
      serviceType === 'engraving_packaging' ||
      serviceType === 'other'
    ) return false;

    var title = String(
      addon.querySelector('.product-addons-popup__addon-name')?.textContent ||
      addon.dataset.addonTitle ||
      ''
    ).toLowerCase();

    if (addon.dataset.vskloPostcard === 'true') return false;
    if (
      title.includes('листів') ||
      title.includes('відкрит') ||
      title.includes('postcard') ||
      title.includes('gift card')
    ) return false;
    if (
      addon.classList.contains('is-package-addon') ||
      addon.classList.contains('no-engraving') ||
      addon.dataset.noEngraving === 'true'
    ) return true;
    if (
      title.includes('грав') ||
      title.includes('нанес') ||
      title.includes('engraving')
    ) return false;

    return (
      title.includes('пакет') ||
      title.includes('пакув') ||
      title.includes('упаков') ||
      title.includes('package') ||
      title.includes('bag')
    );
  }

  function getProp(properties, name) {
    if (!properties) return '';
    return properties[name] || properties[String(name)] || '';
  }

  function create(options) {
    options = options || {};

    var root = options.root;
    var route = options.route;
    var fetchConfigJson = options.fetchConfigJson;
    var cartMutation = options.cartMutation;
    var updateCartDomFromState = options.updateCartDomFromState;
    var collectAddonText = options.collectAddonText;
    var splitAddonText = options.splitAddonText;
    var itemGroup = options.itemGroup;
    var isAddon = options.isAddon;
    var t = options.t;
    var message = options.message;
    var refreshCartPage = options.refreshCartPage;
    var getCartCore = options.getCartCore;
    var getPopupUI = options.getPopupUI;

    if (
      !root ||
      typeof route !== 'function' ||
      typeof fetchConfigJson !== 'function' ||
      typeof cartMutation !== 'function' ||
      typeof updateCartDomFromState !== 'function' ||
      typeof collectAddonText !== 'function' ||
      typeof splitAddonText !== 'function' ||
      typeof itemGroup !== 'function' ||
      typeof isAddon !== 'function' ||
      typeof t !== 'function' ||
      typeof message !== 'function' ||
      typeof refreshCartPage !== 'function'
    ) {
      throw new Error('[VSKLO] cart addon service dependencies are incomplete');
    }

    async function saveAddonText(row, saveOptions) {
      saveOptions = saveOptions || {};
      if (!row) return;

      var originalKey = String(row.dataset.cartKey || '').trim();
      var variantId = Number(row.dataset.variantId || 0);
      var requestedQty = Math.max(
        1,
        parseInt(row.querySelector('[data-vsklo-qty-input]')?.value || '1', 10) || 1
      );
      var requestedGroupId = String(row.dataset.vskloGroupId || '').trim();
      var parentTitle = row.dataset.parentTitle || '';
      var serviceTitle =
        row.dataset.serviceTitle ||
        row.querySelector('.vsklo-addon-title')?.textContent?.trim() ||
        t('additionalService', 'Додаткова послуга');
      var serviceTypeHint = String(
        row.dataset.vskloServiceType ||
        row.dataset.vskloServiceKind ||
        ''
      ).trim();
      var noEngraving = row.dataset.noEngraving === 'true';
      var text = noEngraving ? '' : collectAddonText(row);

      if (!variantId || (!originalKey && !requestedGroupId)) return;

      row.classList.add('is-updating');

      try {
        var result = await cartMutation('save-addon-text', async function () {
          var cartBeforeRes = await fetch(route('cart.js'), {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
          var cartBefore = await cartBeforeRes.json();

          if (!cartBeforeRes.ok || cartBefore.errors || !Array.isArray(cartBefore.items)) {
            throw new Error(
              cartBefore.errors ||
              cartBefore.description ||
              'Could not read cart before saving addon text'
            );
          }

          var currentItem = originalKey
            ? cartBefore.items.find(function (item) {
                return item.key === originalKey && isAddon(item);
              }) || null
            : null;

          if (!currentItem) {
            var identityCandidates = cartBefore.items.filter(function (item) {
              if (!isAddon(item)) return false;
              if (Number(item.variant_id || item.id) !== variantId) return false;
              if (requestedGroupId && itemGroup(item) !== requestedGroupId) return false;
              return true;
            });

            if (identityCandidates.length === 1) {
              currentItem = identityCandidates[0];
            } else if (identityCandidates.length > 1) {
              var normalizedServiceType = serviceTypeHint.toLowerCase().replace(/[\s-]+/g, '_');
              var normalizedServiceTitle = String(serviceTitle || '').trim().toLowerCase();
              var exactCandidates = identityCandidates.filter(function (item) {
                var props = item.properties || {};
                var itemType = String(getProp(props, '_vsklo_service_type') || '')
                  .trim().toLowerCase().replace(/[\s-]+/g, '_');
                var itemTitle = String(
                  getProp(props, '_vsklo_service_title') ||
                  getProp(props, 'Послуга') ||
                  ''
                ).trim().toLowerCase();

                var typeMatches =
                  normalizedServiceType && itemType === normalizedServiceType;
                var titleMatches =
                  normalizedServiceTitle && itemTitle === normalizedServiceTitle;
                return typeMatches || titleMatches;
              });

              if (exactCandidates.length === 1) currentItem = exactCandidates[0];
            }
          }

          if (!currentItem || !currentItem.key) {
            throw new Error(t(
              'unlinkedServiceWarning',
              'Не вдалося однозначно знайти послугу в кошику. Оновіть кошик і спробуйте ще раз.'
            ));
          }

          var authoritativeKey = currentItem.key;
          var existingProps = { ...((currentItem && currentItem.properties) || {}) };
          var groupId = String(
            requestedGroupId ||
            itemGroup(currentItem) ||
            ''
          ).trim();

          if (!groupId) {
            throw new Error(t(
              'unlinkedServiceWarning',
              'Не вдалося підтвердити привʼязку послуги до товару.'
            ));
          }

          var nextProps = {
            ...existingProps,
            _vsklo_schema_version: '2',
            _vsklo_quantity_policy: 'linked_delta',
            _vsklo_text_mode:
              existingProps._vsklo_text_mode ||
              row.dataset.vskloTextMode ||
              (noEngraving ? 'none' : 'same_or_per_unit'),
            _vsklo_role: 'addon',
            _vsklo_addon: 'service',
            _vsklo_group_id: groupId,
            _vsklo_parent_title: existingProps._vsklo_parent_title || parentTitle,
            'Послуга': existingProps['Послуга'] || serviceTitle,
            _vsklo_service_title:
              existingProps._vsklo_service_title ||
              existingProps['_vsklo_service_title'] ||
              serviceTitle,
            _vsklo_service_type:
              existingProps._vsklo_service_type ||
              existingProps['_vsklo_service_type'] ||
              serviceTypeHint ||
              (noEngraving ? 'gift_packaging' : 'engraving_glass')
          };

          var serviceTypeNormalized = String(
            nextProps._vsklo_service_type ||
            serviceTypeHint ||
            ''
          ).toLowerCase().replace(/[\s-]+/g, '_');
          var isPostcardService = serviceTypeNormalized === 'postcard';

          if (noEngraving) {
            nextProps._vsklo_no_engraving = 'true';
            delete nextProps['Текст гравіювання'];
            delete nextProps._vsklo_engraving_text;
            delete nextProps['Текст листівки'];
            delete nextProps._vsklo_postcard_text;
          } else if (text) {
            delete nextProps._vsklo_no_engraving;
            if (isPostcardService) {
              nextProps['Текст листівки'] = text;
              nextProps._vsklo_postcard_text = text;
              delete nextProps['Текст гравіювання'];
              delete nextProps._vsklo_engraving_text;
            } else {
              nextProps['Текст гравіювання'] = text;
              nextProps._vsklo_engraving_text = text;
              delete nextProps['Текст листівки'];
              delete nextProps._vsklo_postcard_text;
            }
          } else {
            delete nextProps._vsklo_no_engraving;
            delete nextProps['Текст гравіювання'];
            delete nextProps._vsklo_engraving_text;
            delete nextProps['Текст листівки'];
            delete nextProps._vsklo_postcard_text;
          }

          var res = await fetch(
            route('cart/change.js'),
            fetchConfigJson({
              id: authoritativeKey,
              quantity: requestedQty,
              properties: nextProps
            })
          );
          var cart = await res.json();

          if (!res.ok || cart.errors || !Array.isArray(cart.items)) {
            throw new Error(
              cart.errors ||
              cart.description ||
              'Could not update addon properties'
            );
          }

          return { cart: cart, groupId: groupId };
        });

        var cart = result.cart;
        var resolvedGroupId = result.groupId;
        var updatedCandidates = (cart.items || []).filter(function (item) {
          if (!isAddon(item)) return false;
          return (
            Number(item.variant_id || item.id) === variantId &&
            itemGroup(item) === resolvedGroupId
          );
        });

        var updatedItem =
          updatedCandidates.length === 1 ? updatedCandidates[0] : null;

        if (!updatedItem && updatedCandidates.length > 1) {
          var normalizedServiceType = serviceTypeHint.toLowerCase().replace(/[\s-]+/g, '_');
          var normalizedServiceTitle = String(serviceTitle || '').trim().toLowerCase();
          var exactCandidates = updatedCandidates.filter(function (item) {
            var props = item.properties || {};
            var itemType = String(getProp(props, '_vsklo_service_type') || '')
              .trim().toLowerCase().replace(/[\s-]+/g, '_');
            var itemTitle = String(
              getProp(props, '_vsklo_service_title') ||
              getProp(props, 'Послуга') ||
              ''
            ).trim().toLowerCase();

            return (
              (normalizedServiceType && itemType === normalizedServiceType) ||
              (normalizedServiceTitle && itemTitle === normalizedServiceTitle)
            );
          });
          if (exactCandidates.length === 1) updatedItem = exactCandidates[0];
        }

        if (!updatedItem || !updatedItem.key) {
          throw new Error(t(
            'unlinkedServiceWarning',
            'Послугу збережено, але не вдалося однозначно оновити її рядок у кошику.'
          ));
        }

        row.dataset.cartKey = updatedItem.key;
        row.dataset.vskloGroupId = resolvedGroupId;
        var qtyBox = row.querySelector('[data-vsklo-qty]');
        if (qtyBox) qtyBox.dataset.key = updatedItem.key;

        delete row.dataset.vskloDirty;
        updateCartDomFromState(cart);
      } catch (error) {
        console.error('VSKLO save addon failed', error);
        row.dataset.vskloDirty = '1';

        if (!saveOptions.silent) {
          message(t(
            'saveTextError',
            'Не вдалося зберегти текст. Спробуйте ще раз.'
          ));
        }
        throw error;
      } finally {
        row.classList.remove('is-updating');
      }
    }

    async function ensurePersistentParentGroup(popup, button, requestedGroupId) {
      var parentKey = popup?.dataset?.vskloParentKey || '';
      var parentVariantId = Number(button?.dataset?.parentVariantId || 0);

      return cartMutation('persist-parent-group', async function () {
        var cartRes = await fetch(route('cart.js'), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        var cart = await cartRes.json();

        if (!cartRes.ok || cart.errors || !Array.isArray(cart.items)) {
          throw new Error(
            cart.errors ||
            cart.description ||
            'Could not read cart before adding service'
          );
        }

        var parentItem =
          (cart.items || []).find(function (item) {
            return item.key === parentKey && !isAddon(item);
          }) || null;

        if (!parentItem && parentVariantId) {
          var candidates = (cart.items || []).filter(function (item) {
            return !isAddon(item) &&
              Number(item.variant_id || item.id) === parentVariantId;
          });

          if (requestedGroupId) {
            var groupCandidates = candidates.filter(function (item) {
              return itemGroup(item) === requestedGroupId;
            });
            if (groupCandidates.length === 1) parentItem = groupCandidates[0];
          } else if (candidates.length === 1) {
            parentItem = candidates[0];
          }
        }

        if (!parentItem) {
          throw new Error(t(
            'unlinkedServiceWarning',
            'Не вдалося однозначно знайти основний товар для цієї послуги.'
          ));
        }

        var existingGroupId = itemGroup(parentItem);
        var groupId = String(
          existingGroupId ||
          requestedGroupId ||
          parentItem.key ||
          ''
        ).trim();

        if (!groupId) {
          throw new Error(t(
            'unlinkedServiceWarning',
            'Не вдалося створити привʼязку послуги до товару.'
          ));
        }

        var nextCart = cart;
        var updatedParent = parentItem;

        if (!existingGroupId) {
          var nextProperties = {
            ...((parentItem && parentItem.properties) || {}),
            _vsklo_group_id: groupId
          };

          var changeRes = await fetch(
            route('cart/change.js'),
            fetchConfigJson({
              id: parentItem.key,
              quantity: Math.max(1, Number(parentItem.quantity || 1)),
              properties: nextProperties
            })
          );
          nextCart = await changeRes.json();

          if (!changeRes.ok || nextCart.errors || !Array.isArray(nextCart.items)) {
            throw new Error(
              nextCart.errors ||
              nextCart.description ||
              'Could not persist parent group'
            );
          }

          var parentCandidates = (nextCart.items || []).filter(function (item) {
            return (
              !isAddon(item) &&
              Number(item.variant_id || item.id) ===
                Number(parentItem.variant_id || parentItem.id) &&
              itemGroup(item) === groupId
            );
          });
          updatedParent =
            parentCandidates.length === 1 ? parentCandidates[0] : null;

          if (!updatedParent) {
            throw new Error(t(
              'unlinkedServiceWarning',
              'Не вдалося однозначно підтвердити привʼязку основного товару.'
            ));
          }
        }

        if (updatedParent?.key) {
          popup.dataset.vskloParentKey = updatedParent.key;
          button.dataset.parentGroup = groupId;
          button.dataset.parentQuantity = String(
            Math.max(1, Number(updatedParent.quantity || 1))
          );

          var parentCards = Array.from(
            root.querySelectorAll('[data-vsklo-parent-card]')
          );
          var parentCard =
            parentCards.find(function (card) {
              return card.dataset.cartKey === parentKey;
            }) || null;

          if (!parentCard && groupId) {
            var groupCards = parentCards.filter(function (card) {
              return card.dataset.vskloGroupId === groupId;
            });
            if (groupCards.length === 1) parentCard = groupCards[0];
          }

          if (!parentCard) {
            var updatedVariantId = Number(
              updatedParent.variant_id || updatedParent.id || 0
            );
            var variantCandidates = parentCards.filter(function (card) {
              return Number(card.dataset.variantId || 0) === updatedVariantId;
            });
            if (variantCandidates.length === 1) {
              parentCard = variantCandidates[0];
            }
          }

          if (parentCard) {
            parentCard.dataset.cartKey = updatedParent.key;
            parentCard.dataset.vskloGroupId = groupId;
            var parentQtyBox = parentCard.querySelector(
              ':scope > .vsklo-cart-card-main [data-vsklo-qty]'
            );
            if (parentQtyBox) parentQtyBox.dataset.key = updatedParent.key;
          }
        }

        return {
          groupId: groupId,
          cart: nextCart,
          parent: updatedParent
        };
      });
    }

    async function addServicesToExistingProduct(popup, button) {
      if (!popup || !button) return;
      if (button.dataset.vskloSubmitting === '1') return;

      var popupUI = typeof getPopupUI === 'function' ? getPopupUI() : null;
      var cartCore = typeof getCartCore === 'function' ? getCartCore() : null;

      if (!popupUI || !cartCore) {
        throw new Error('[VSKLO] cart addon service runtime is not fully initialized');
      }

      var groupId = button.dataset.parentGroup || '';
      var parentTitle = button.dataset.parentTitle || '';
      var parentVariantId = button.dataset.parentVariantId || '';
      var parentQty = Math.max(
        1,
        parseInt(button.dataset.parentQuantity || '1', 10) || 1
      );

      if (!popupUI.validateSelectedPopupServices(popup)) return;

      var selectedByVariant = new Map();

      popup.querySelectorAll(
        '.product-addons-popup__addon-checkbox:checked'
      ).forEach(function (checkbox) {
        if (!popupUI.isCartAddonSelectableForSubmit(checkbox)) return;

        var addonVariantId = Number(checkbox.dataset.addonVariantId || 0);
        if (!addonVariantId) return;

        var addon = checkbox.closest('.product-addons-popup__addon');
        var title =
          addon?.querySelector('.product-addons-popup__addon-name')
            ?.textContent?.trim() ||
          t('additionalService', 'Додаткова послуга');
        var noEngraving = isNoEngravingAddon(addon);
        var serviceType = getAddonServiceType(addon);
        var text = noEngraving ? '' : collectAddonText(addon);
        var quantity = parentQty;
        var existing = selectedByVariant.get(String(addonVariantId));

        if (!existing) {
          selectedByVariant.set(String(addonVariantId), {
            addonVariantId: addonVariantId,
            title: title,
            text: text,
            noEngraving: noEngraving,
            serviceType: serviceType,
            quantity: quantity
          });
        } else if (!existing.text && text) {
          existing.text = text;
        }
      });

      var selected = Array.from(selectedByVariant.values());
      if (!selected.length) return;

      button.dataset.vskloSubmitting = '1';
      button.classList.add('loading');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        await cartCore.flushPendingQuantityUpdates();

        if (root.querySelector('[data-vsklo-addon-row][data-vsklo-dirty="1"]')) {
          await cartCore.waitForAddonSaves(
            'VSKLO previous addon autosave failed; retrying before service update'
          );
          await cartCore.flushDirtyAddonTextRows();
        }

        var parentState = await ensurePersistentParentGroup(
          popup,
          button,
          groupId
        );
        groupId = parentState.groupId;
        parentQty = Math.max(
          1,
          Number(
            parentState.parent?.quantity ||
            button.dataset.parentQuantity ||
            parentQty
          ) || 1
        );
        selected.forEach(function (service) {
          service.quantity = parentQty;
        });

        var cart = parentState.cart || { items: [] };
        if (!Array.isArray(cart.items)) cart = { items: [] };

        // Re-selecting an already linked paid service is idempotent. It must
        // NEVER double its quantity, price or stored engraving text. Serialize
        // the authoritative read and the ONE add in the same mutation slot.
        var operation = await cartMutation('add-cart-services-idempotently', async function () {
          var latestResponse = await fetch(route('cart.js'), {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!latestResponse.ok) throw new Error('Could not verify the cart before adding services');
          var latestCart = await latestResponse.json();
          if (!Array.isArray(latestCart.items)) throw new Error('Invalid cart before adding services');

          var parentKey = String(parentState.parent?.key || popup.dataset.vskloParentKey || '');
          var activeParent = latestCart.items.find(function (item) {
            return item.key === parentKey && !isAddon(item) && itemGroup(item) === groupId;
          }) || null;
          if (!activeParent) {
            var candidates = latestCart.items.filter(function (item) {
              return !isAddon(item) && itemGroup(item) === groupId &&
                Number(item.variant_id || item.id) === Number(parentVariantId);
            });
            if (candidates.length === 1) activeParent = candidates[0];
          }
          if (!activeParent) {
            throw new Error(t('unlinkedServiceWarning',
              'Не вдалося однозначно підтвердити товар. Оновіть кошик і спробуйте ще раз.'));
          }

          var actualParentQty = Math.max(1, Number(activeParent.quantity || 1));
          var preservedCount = 0;
          var itemsToAdd = [];
          selected.forEach(function (sel) {
            var alreadyLinked = latestCart.items.some(function (item) {
              if (!isAddon(item) || itemGroup(item) !== groupId) return false;
              return Number(item.variant_id || item.id) === Number(sel.addonVariantId);
            });
            if (alreadyLinked) {
              preservedCount += 1;
              return;
            }

            var properties = {
              _vsklo_schema_version: '2',
              _vsklo_quantity_policy: 'linked_delta',
              _vsklo_text_mode: sel.noEngraving ? 'none' : 'same_or_per_unit',
              _vsklo_role: 'addon',
              _vsklo_addon: 'service',
              _vsklo_group_id: groupId,
              _vsklo_parent_variant_id: String(activeParent.variant_id || activeParent.id),
              _vsklo_parent_title: parentTitle,
              'Послуга': sel.title,
              _vsklo_service_title: sel.title,
              _vsklo_service_type: sel.serviceType || (sel.noEngraving ? 'gift_packaging' : 'engraving_glass')
            };
            if (sel.noEngraving) {
              properties._vsklo_no_engraving = 'true';
            } else if (sel.text) {
              var textKey = sel.serviceType === 'postcard' ? 'Текст листівки' : 'Текст гравіювання';
              var privateKey = sel.serviceType === 'postcard' ? '_vsklo_postcard_text' : '_vsklo_engraving_text';
              properties[textKey] = sel.text;
              properties[privateKey] = sel.text;
            }
            itemsToAdd.push({
              id: sel.addonVariantId,
              quantity: actualParentQty,
              properties: properties
            });
          });

          if (!itemsToAdd.length) return { added: 0, preserved: preservedCount };
          var response = await fetch(route('cart/add.js'), fetchConfigJson({ items: itemsToAdd }));
          var addData = await response.json();
          if (!response.ok || addData.status || addData.errors) {
            throw new Error(addData.description || addData.message || 'Could not add the selected services');
          }
          return { added: itemsToAdd.length, preserved: preservedCount };
        });

        popupUI.closePopup(popup);
        message(operation.added
          ? t('serviceAdded', 'Послугу додано. Оновлюємо кошик…')
          : t('serviceAlreadyLinked', 'Цю послугу вже додано. Змінити текст або кількість можна в кошику.'));

        try {
          await refreshCartPage();
        } catch (refreshError) {
          console.warn(
            'VSKLO cart service UI refresh failed; reloading authoritative state',
            refreshError
          );
          window.location.reload();
        }
      } catch (error) {
        console.error('VSKLO add services failed', error);
        message(t(
          'addServiceError',
          'Не вдалося додати послугу. Стан кошика буде оновлено.'
        ));
        window.setTimeout(function () {
          window.location.reload();
        }, 650);
      } finally {
        button.classList.remove('loading');
        button.disabled = false;
        button.removeAttribute('aria-busy');
        delete button.dataset.vskloSubmitting;
      }
    }

    return Object.freeze({
      saveAddonText: saveAddonText,
      ensurePersistentParentGroup: ensurePersistentParentGroup,
      addServicesToExistingProduct: addServicesToExistingProduct
    });
  }

  window.VSKLOCartAddonService = Object.freeze({
    create: create,
    normalizeAddonType: normalizeAddonType,
    getAddonServiceType: getAddonServiceType,
    getRequiredTextMessage: getRequiredTextMessage,
    isNoEngravingAddon: isNoEngravingAddon,
    getProp: getProp
  });
})();